import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  SCHOOL_HEALTH_NOTIFICATIONS_DETAILS_PATH,
  SCHOOL_HEALTH_NOTIFICATIONS_PATH,
} from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const SchoolHealthNotificationListPage = lazy(
  () => import('./pages/SchoolHealthNotificationListPage/SchoolHealthNotificationListPage')
);
const SchoolHealthNotificationPage = lazy(
  () => import('./pages/SchoolHealthNotificationPage/SchoolHealthNotificationPage')
);

export const SCHOOL_HEALTH_NOTIFICATION_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.MOBILE, LayoutType.PORTAL],
    component: () => <SchoolHealthNotificationListPage />,
    displayTitle: () => 'School Health Updates',
    pageType: PageType.PRIVATE,
    path: SCHOOL_HEALTH_NOTIFICATIONS_PATH,
    serviceCatalogCode: '',
  },
  {
    availableViews: [LayoutType.MOBILE, LayoutType.PORTAL],
    component: () => <SchoolHealthNotificationPage />,
    displayTitle: () => 'School Health Updates',
    pageType: PageType.PRIVATE,
    path: SCHOOL_HEALTH_NOTIFICATIONS_DETAILS_PATH,
    serviceCatalogCode: '',
  },
];
